<template>
  <div id="app">
    <div v-show="$store.state.DLINE_ENVIRONMENT" id="devenvironment_warning" style="position:fixed;z-index:10000;top:0;width:100px;margin-left:-50px;left:50%;background-color:#ffb734;text-align:center;padding:10px;border-radius:0 0 4px 4px;opacity:.5;font-weight:bold;pointer-events:none;">{{$store.state.DLINE_ENVIRONMENT}}</div>
    <!-- <keep-alive> -->
        <!-- 需要缓存的视图组件 --> 
        <!-- <router-view v-if="$route.meta.keepAlive"></router-view>
     </keep-alive> -->
      <!-- 不需要缓存的视图组件 -->
     <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <keep-alive :include="keepAlivePage">
      <router-view></router-view>
    </keep-alive>
    <!-- 用户角色信息切换 开始 -->
    <div class="userdata_content" v-if="selectUserType">
      <div class="mask"></div>
      <div class="userdata_wrap">
        <div class="titles">切换组织身份</div>
        <div class="list_user">
          <div class="item_user" :class="{active: item.is_choose==1}" v-for="(item, index) in UserList" :key="index" @click="choose_userdata(item)">
            <i class="material-icons icon" v-if="item.is_choose==0">&#xe40c;</i>
            <i class="material-icons icon" v-else>&#xe39e;</i>
            <div class="title_wrap">
              <span class="title">{{item.name}}</span>
              <span class="badges" v-if="item.natureCode!='store'">[ {{item.parent_name?item.parent_name:'--'}} ]</span>
              <span class="badges" v-else>[ 门店 ]</span>
            </div>
          </div>
        </div>
        <div class="btn_box">
          <div class="btn btn_color_1 btn_shadow" @click="btn_choose_user">确认</div>
        </div>
      </div>
    </div>
    <!-- 用户角色信息切换 结束 -->

    <template v-if="$store.state.IS_COMPUTER">
       <!-- 购物车 -->
      <template v-if="$route.name == 'Credit' || $route.name == 'CreditView'">
        <div class="float_tools" style="bottom: 145px;">
            <router-link class="btn btn_backhome" title="购物车" :to="{name: 'Cart'}">
               <van-badge :content="$store.state.cartnum" max="99">
                <img src="../static/img/cartimg/shop_cart.png" alt="" style="border: none;width:25px;height: 25px;">
              </van-badge>
            </router-link>    
        </div>
      </template>
    </template>


    <template v-if="$store.state.IS_COMPUTER && !$store.state.browser.giantopoapp">
      <template v-if="isShowFloatTools">
        <div class="float_tools" v-if="isShowFloatTools">
          <router-link class="btn btn_backhome" title="回到首页" :to="{name: 'Index'}"><i class="material-icons">&#xe88a;</i></router-link>    
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      //登录角色信息
      UserList: [],
      selectUserType: false,
      setTimeeach: '',
    };
  },
  watch: {
  },
  computed: {
    isShowFloatTools() {
      let ary = ['Sso', 'VerifiyInfo', 'Cart', 'CartAdress', 'Turntable', 'ListView', 'ViewCurriculumViews', 'StudyView', 'PcStudyView', 'ExamViews'];
      return !ary.includes(this.$route.name);
    },


    keepAlivePage() {
      let a = ['Selfstudy', 'Train', 'Special', 'Credit', 'Driedfood', 'Studymap', 'StudyList'];
      let b = this.$store.state.keepAlivePage;
      // 检查是否有相同字符
      const hasCommonItems = a.some(item => b.includes(item));
      // console.log('是否有相同字符:', hasCommonItems); // true
      // 合并数组并去重
      const mergedArray = [...new Set([...a, ...b])];
      return mergedArray;
    }
  },
  created() {
    const _this = this;
    // console.log(_this.$router)
    // console.log(_this.$route)

    if(document.body.clientWidth > 640){
      document.querySelector('body').setAttribute('style', 'background-color:#F8FBFF')
    }else{
      document.querySelector('body').setAttribute('style', 'background-color:#ffffff')
    }

    _this.setTimeeach = setInterval(function () {
      let ary = ['ListView', 'ViewCurriculumViews', 'StudyView', 'PcStudyView', 'ExamViews'];
      // console.log(!ary.includes(_this.$route.name))
      if (!ary.includes(_this.$route.name)) {
        if( _this.$store.state.loginUser.sessionkey && localStorage.getItem('giant_userselect') == '0' ){
          // alert(localStorage.getItem('giant_userselect'));
          _this.getSelectOrgData();
  
          clearInterval(_this.setTimeeach);
        }else if( _this.$store.state.loginUser.sessionkey && localStorage.getItem('giant_userselect') == '1' ){
          // alert(localStorage.getItem('giant_userselect'));
          clearInterval(_this.setTimeeach);
        }else{
          clearInterval(_this.setTimeeach);
        }
      }else{
        clearInterval(_this.setTimeeach);
      }
    }, 200);
  },
  mounted() {
    const _this = this;
    
    window.addEventListener("resize", function() {
      return (() => {
        window.screenWidth= document.body.clientWidth;
        if( window.screenWidth > 640 ){
          _this.$store.state.IS_COMPUTER = false;

           document.querySelector('body').setAttribute('style', 'background-color:#F8FBFF')
        }else{
          _this.$store.state.IS_COMPUTER = true;

           document.querySelector('body').setAttribute('style', 'background-color:#ffffff')
        }
      })();
    });
  },
  watch: {
    '$route': {
      handler(to, from){
        //console.log(to);
        //console.log(from);
        //console.log(this.$store.state.browser);
        if(this.$store.state.browser.ios && this.$store.state.browser.giantapp){
          if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'; //改为manual之后，就不会记录滚动位置
          }
        }
      },
      immediate: true,//首次进入页面即执行
    },
  },
  methods: {
    
    //获取登录身份
    getSelectOrgData(){
      const _this = this;
      
      _this.axios
      .post(
        _this.$store.state.api.gra_api + "login/selectOrgData",
        _this.qs.stringify({
          token: _this.$store.state.loginUser.sessionkey
        })
      )
      .then(function (res) {
        if (res.status == 200) {
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast.fail("载入登录角色信息失败：接口异常");

              localStorage.removeItem('giant_userdata');
              _this.$store.commit('updateLoginUser', false);

              return false;
            }
          }
          if (res.data.status == 1) {

            _this.UserList = res.data.data;
            _this.selectUserType = true;
            
          }else if(res.data.status == 2){
            _this.$dialog.confirm({
              closeOnPopstate: true,//页面回退时自动关闭
              title: '当前账号已在其他设备登录',
              message: _this.$store.state.browser.giantopoapp?'如需继续操作，返回后请重新打开GRA':'请重新登录',
              showCancelButton: false,
              confirmButtonText: _this.$store.state.browser.giantopoapp?'我知道了':'前往登录',
            }).then(() => {
              localStorage.removeItem('giant_userdata');
              _this.$store.commit('updateLoginUser', false);

              if( _this.$store.state.browser.giantopoapp  ){
                if( _this.$store.state.browser.ios ){
                  window.webkit.messageHandlers.back.postMessage('');
                }else{
                  android.back();
                }
              }else{
                _this.$router.replace({ path: '/login', query: { redirect: location.href }});
              }
            }).catch(() => {
            });
          } else {
            localStorage.removeItem('giant_userdata');
            _this.$store.commit('updateLoginUser', false);

            _this.$toast.fail(
              res.data.msg ? res.data.msg : "载入登录角色信息失败：出现了一些问题"
            );
          }
        } else {
          localStorage.removeItem('giant_userdata');
          _this.$store.commit('updateLoginUser', false);

          _this.$toast.fail("载入登录角色信息失败：网络加载失败，请稍候再试");
        }
      })
      .catch(function (error) {
        localStorage.removeItem('giant_userdata');
        _this.$store.commit('updateLoginUser', false);
        if (error.response && error.response.status == 503) {
          _this.countDown503();
        }else{
          _this.$toast.fail("载入登录角色信息失败");
        }
        
        console.error(error);
      });
    },

    //切换组织身份
    choose_userdata(tmp_data) {
      const _this = this;

      _this.UserList.forEach(function(item, index){
        if( tmp_data.org_id == item.org_id ){
          item.is_choose = 1;
        }else{
          item.is_choose = 0;
        }
      })
    },

    //确认选择组织身份
    btn_choose_user(){
      const _this = this;

      let userinfo = {};
      let _type = 1;

      _this.UserList.forEach(function(item, index){
        if( item.is_choose == 1 ){
          userinfo = item;
          _type = 0;
        }
      });

      if( _type == 1 ){
        _this.$toast.fail('请选择需要的组织身份登录');
        return false;
      }

      _this.axios.post(_this.$store.state.api.gra_api + 'login/doSelectOrgData', _this.qs.stringify({
        org_id: userinfo.org_id,
        user_id: _this.$store.state.loginUser.id,
        token: _this.$store.state.loginUser.sessionkey
      })).then(function(res){
        if( res.status == 200 ){
          if (typeof res.data != "object") {
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              _this.$toast.fail("提交失败：接口异常");
              console.error(error);
              return false;
            }
          }
          if( res.data.status == 1 ){

            let fetch_data = res.data.data;

            let loginuser_data = JSON.parse(localStorage.getItem('giant_userdata'));
            
            loginuser_data.usercode = fetch_data.code;
            loginuser_data.code_name = fetch_data.code_name;

            loginuser_data.user_type = fetch_data.user_type;
            loginuser_data.shopno = fetch_data.shopno;
            loginuser_data.dealercode = fetch_data.dealercode;
            loginuser_data.dealer_name = fetch_data.dealer_name;
            loginuser_data.sbucode = fetch_data.sbu;
            loginuser_data.sbu_name = fetch_data.sbu_name;
            loginuser_data.parentInfo = fetch_data.parentInfo;

            _this.$store.commit('updateLoginUser', loginuser_data);
            localStorage.setItem('giant_userdata', JSON.stringify(loginuser_data));

            localStorage.removeItem('giant_userselect');

            if( _this.$store.state.browser.giantopoapp ){
              if( _this.$store.state.browser.ios ){
                window.webkit.messageHandlers.changeOrg.postMessage(JSON.stringify(fetch_data.parentInfo.org_id))
              }else{
                android.changeOrg(fetch_data.parentInfo.org_id);
              }
            }

            _this.selectUserType = false;

            // location.reload();
          } else if(res.data.status == 2){
            _this.reloginPopup()
          }else {
            _this.$toast(res.data.msg?res.data.msg:'出现了一些问题');
          }
        }else{
          _this.$toast('提交失败');
        }
      }).catch(function (error) {
        if (error.response && error.response.status == 503) {
          _this.countDown503();
        } else{
          _this.$toast('出现了一些问题');
        }


      })

    },
  }
}
</script>

<style lang="less">
.el-message-box{
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  width: auto !important;
}
@import "./assets/css/computer.less";

.userdata_content {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 12;
  .mask {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: .8;
    z-index: 0;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }
  .userdata_wrap {
    width: 90%;
    max-width: 512px;
    max-height: 75%;
    overflow-y: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    z-index: 9999;
    .titles {
      font-size: 18px;
      padding-bottom: 20px;
      text-align: center;
    }
    .list_user {
      .item_user {
        display: flex;
        align-items: center;
        padding: 10px 0;
        cursor: pointer;
        .icon {
          flex-shrink: 0;
          color: #34497E;
        }
        .title_wrap {
          color: #34497E;
          padding-left: 10px;
          flex: 1;
          font-size: 14px;
          .badges {
          }
        }
        &.active {
          .icon,
          .title_wrap {
            color: #4E66FF;
          }
        }
      }
    }
    .btn_box {
      margin-top: 20px;
      .btn {
        display: block;
        line-height: 40px;
      }
    }
  }
}
</style>

<style lang="less">
/** 右下角浮动按钮 通用 **/
.float_tools {
  display: block;
  position: fixed;
  right: 10px;
  bottom: 90px;
  z-index: 10;
  font-size: 0;
  width: 40px;
}
.float_tools .btn {
  border-radius: 100px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  opacity: .9;
  background-color: #333;
  color: #fff;
  margin-top: 5px;
  position: relative;
}
.float_tools .btn > .material-icons {
  line-height: inherit;
  vertical-align: top;
}
.float_tools .btn:hover {
  opacity: 1;
}
.float_tools .btn > .badge {
  position: absolute;
  padding: 0 4px;
  min-width: 24px;
  text-align: center;
  border-radius: 100px;
  transform: scale(0.8);
  top: -5px;
  left: 50%;
  margin-left: 5px;
}
.float_tools .btn_scroll_to_top {
  display: none;
}
.float_tools .btn_scroll_to_top.active {
  display: block;
  -webkit-animation: scroll_to_top_ani .3s ease-out;
  animation: scroll_to_top_ani .3s ease-out ;
}

@-webkit-keyframes scroll_to_top_ani {
  0% {
    -webkit-transform: scale(0);
  }
  80% {
    -webkit-transform: scale(1.2);
  }
  100% {
    -webkit-transform: scale(1);
    opacity: .8;
  }
}

@keyframes scroll_to_top_ani {
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.float_tools .btn_backhome {
  background-color: #4E66FF;
}
.float_tools .btn_cart {
  /*background-color:#ff7e00;*/
}
.float_tools .btn_favorite {
  background-color: rgba(239, 58, 58, .5);
  text-shadow: 0 0 10px #ef3a3a;
  box-shadow: inset 0 0 20px rgba(239, 58, 58, .5);
}
.float_tools .btn_favorite.active {
  background-color: #ef3a3a;
  color: #fff;
  text-shadow: none;
}
.float_tools .btn_favorite.active .no,
.float_tools .btn_favorite .ok {
  display: none;
}
.float_tools .btn_favorite.active .ok {
  display: inline-block;
}
.float_tools .btn_favorite.active {
  -webkit-animation: scroll_to_top_ani .3s ease-out;
  animation: scroll_to_top_ani .3s ease-out ;
}
</style>



// WEBPACK FOOTER //
// src/App.vue